import PropTypes from "prop-types";
import React from "react";
import media from "styled-media-query";
import breakpoints from "Helpers/BreakpointHelper";
import { H2 } from "BaseComponents/Text";
import {
  PagePuffWrapper,
  PagePuffText,
  PagePuffContainer,
  PagePuffOuterWrapper,
} from "../PagePuff/components";
import LazyBackgroundImage from "../../framework/lazy/LazyBackgroundImage";
import { HeaderLink } from "BaseComponents/Link";
import { RTEWrapper } from "BaseComponents/Wrappers";
import styled from "styled-components";
import { GetTextColor } from "Helpers/ColorHelper";
import { Video, VideoWrapper } from "Components/Video";
const VideoContainer = styled.div`
  margin: ${({ margin }) => (margin ? margin : "")};
  ${VideoWrapper} {
    width: 100%;
  }
  width: 100%;
  height: 100%;
  ${media.lessThan(breakpoints.mobile)`
	margin-bottom: 20px;
	max-height: 303px;

button{
    height: 40px;
    width: 40px;
    i{
        font-size: 30px;
    }
}
    h1{
        margin-left: 20px;
        font-size: 16px;
        line-height: 24px;
        
    }
`};
`;
export const ColumnBlock = ({
  Heading,
  Image,
  Link,
  Preamble,
  ImageToTheRight,
  BackgroundColor,
  VideoType,
  VideoLink,
  DecreaseDistance,
}) => {
  const { textColor } = GetTextColor(BackgroundColor);

  return (
    <PagePuffOuterWrapper bgColor={BackgroundColor} className="columnBlock">
      <PagePuffContainer className="page-puff">
        <PagePuffWrapper
          smallwidth="auto"
          padding="3rem 1rem"
          margin="0 auto"
          alignItems="center"
          justifycontent={DecreaseDistance ? "center" : "space-between"}
          flexdir={!ImageToTheRight ? "row-reverse" : "row"}
          smallflexdirection="column-reverse"
          autoWidth={true}
          className="pagePuffWrapperInner"
        >
          <PagePuffWrapper
            justifycontent="center"
            column={true}
            padding={
              DecreaseDistance
                ? !ImageToTheRight
                  ? "1.5rem 0rem 0rem 1rem"
                  : "1.5rem 1rem 0rem 0rem"
                : "1.5rem 0rem 0rem 0rem"
            }
            smallpadding="1rem 0 0 0"
            flex="1 40%"
            flexgrow="0"
          >
            <H2 color={textColor}>{Heading}</H2>
            {Preamble && (
              <RTEWrapper
                color={textColor}
                maxWidth="530px"
                margin="1rem 0"
                dangerouslySetInnerHTML={{
                  __html: Preamble,
                }}
              ></RTEWrapper>
            )}
            {Link != undefined && (
              <HeaderLink
                inverted
                width="fit-content"
                margin="2rem 0"
                target={Link.Target}
                href={Link.Url}
                text={Link.Name}
                ariaLabel={Link.Name}
                color={textColor}
              />
            )}
          </PagePuffWrapper>
          <PagePuffWrapper
            justifycontent="center"
            padding="0"
            alignItems="center"
            smallpadding="0"
            flex="1 43.5%"
            flexgrow="0"
            className="imagePagePuffWrapper"
          >
            {Image &&
              (VideoLink ? (
                <VideoContainer>
                  <Video
                    Image={Image}
                    VideoType={VideoType}
                    VideoLink={VideoLink}
                  />
                </VideoContainer>
              ) : (
                <LazyBackgroundImage maxHeight="303px" source={Image} />
              ))}
          </PagePuffWrapper>
        </PagePuffWrapper>
      </PagePuffContainer>
    </PagePuffOuterWrapper>
  );
};

ColumnBlock.propTypes = {
  Heading: PropTypes.string,
  Image: PropTypes.object,
  Preamble: PropTypes.string,
  ImgToTheRight: PropTypes.bool,
  Link: PropTypes.string,
};
